/* eslint-disable react/display-name */
import React from 'react';
import { Switch } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import Branch from '../container/Branch';
import BranchDetail from '../container/Branch/DetailBranch';
import AddBranch from '../container/Branch/AddBranch';
import { ADMIN_ROUTES } from '../constants/router';

const routes = [
  {
    path: `${ADMIN_ROUTES.STATISTICAL_BRANCH}`,
    component: () => <Branch />,
    exact: true,
    meta: {
      action: 'branch_view',
      subject: 'branch'
    }
  },
  {
    path: `${ADMIN_ROUTES.STATISTICAL_BRANCH}/detail/:id`,
    component: () => <BranchDetail />,
    exact: true
  },
  {
    path: `${ADMIN_ROUTES.STATISTICAL_BRANCH}/:type`,
    component: () => <AddBranch />,
    exact: true
    // meta: {
    //   action: "branch_add",
    //   subject: "branch",
    // },
  },
  {
    path: `${ADMIN_ROUTES.STATISTICAL_BRANCH}/:type/:id`,
    component: () => <AddBranch />,
    exact: true
    // meta: {
    //   action: "branch_edit",
    //   subject: "branch",
    // },
  }
];

const BranchRoutes = () => {
  if (typeof window !== 'undefined') {
    return (
      <>
        <Switch>
          {routes.map((route) => (
            <AuthRoute key={route.path} {...route} />
          ))}
        </Switch>
      </>
    );
  }
  return '';
};

export default BranchRoutes;
